import Appointment2 from '@/components/Appointment2';
import Banner from '@/components/Banner2';
import { FEATURES_LIST } from './index.js';
import Features from '@/components/Features';
import Function from './components/Function';
import Cases from './components/Cases';
export default {
  components: {
    Appointment2,
    Banner,
    Features,
    Function,
    Cases
  },
  data() {
    return {
      featuresList: FEATURES_LIST,
      productId: this.$productId.TOU_GU.REN_GONG_TOU_GU
    };
  }
};